import { render } from "./PaymentLinks.vue?vue&type=template&id=c4a6496a&scoped=true"
import script from "./PaymentLinks.vue?vue&type=script&lang=js"
export * from "./PaymentLinks.vue?vue&type=script&lang=js"

import "./PaymentLinks.vue?vue&type=style&index=0&id=c4a6496a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a6496a"]])

export default __exports__